import { useEffect } from 'react';

import isNil from 'lodash/isNil';

import { CheckoutInputDataModel, CheckoutInputDataModelValidationSchema } from '@app/models';
import { checkoutDetailsSlice, useAppDispatch } from '@app/state';

export const useInitialCheckoutDataFetch = ({
    inputData,
}: {
    inputData: CheckoutInputDataModel | null | undefined;
}) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (isNil(inputData)) return;

        CheckoutInputDataModelValidationSchema.isValid(inputData)
            .then(valid => {
                if (!valid) {
                    return;
                }

                dispatch(
                    checkoutDetailsSlice.actions.fetchCheckoutDetailsThunk(
                        inputData as CheckoutInputDataModel,
                    ),
                );
            })
            .catch(console.error);
    }, [inputData]);
};
